import { useMemo } from 'react';
import { Trans } from 'react-i18next';
import styled from 'styled-components';
import { BaseBadge } from 'src/components/pages/conversations/components/contact-interactions/items/phone-call-analysis/components/base-badge';

const InteractionDetailsBadgeStrongText = styled.span`
  color: ${({ theme }) => theme.colors.smalt};
  font-family: ${({ theme }) => theme.font.medium};
  font-size: 12px;
  line-height: 14px;
`;

const InteractionDetailsBadgeContainer = styled(BaseBadge)<{
  $type: 'success' | 'partially-achieved' | 'negative' | 'neutral';
}>`
  cursor: pointer;

  ${({ $type, theme }) =>
    $type === 'success' &&
    `
  background-color: #f5fdf8;
  border-color: #c6ebd8;

  .badge-icon {
    svg path {
      fill: #7ec69f;
    }
  }

  .badge-content {
    ${InteractionDetailsBadgeStrongText} {
      color: ${theme.colors.secondaryMintDark};
    }
  }
`};

  ${({ $type, theme }) =>
    $type === 'negative' &&
    `
    background-color: #fff7f8;
    border-color: #fee3e4;

    .badge-icon  {
      svg path {
        fill: ${theme.colors.secondaryCoralDark};
      }
    }

    .badge-content {
      ${InteractionDetailsBadgeStrongText} {
        color: ${theme.colors.secondaryCoralDark};
      }
    
  }`};

  ${({ $type, theme }) =>
    $type === 'partially-achieved' &&
    `
  background-color: ${theme.colors.white};
  border-color: rgba(204, 150, 0, 0.35);

  .badge-icon {
    svg path {
      fill: ${theme.colors.secondaryGoldDark};
    }
  }

  .badge-content {
    ${InteractionDetailsBadgeStrongText} {
      color: ${theme.colors.secondaryGoldDark};
    }
  }
`};
`;

type InteractionDetailsBadgeProps = {
  icon: string;
  title: string;
  type: 'success' | 'partially-achieved' | 'negative' | 'neutral';
  inProgress?: boolean;
  onClick?: VoidFunction;
  'data-lgg-id'?: string;
};

export const InteractionDetailsBadge = ({
  icon,
  title,
  type,
  inProgress = false,
  ...rest
}: InteractionDetailsBadgeProps) => {
  const badgeContent = useMemo(() => {
    if (inProgress) {
      return (
        <Trans
          i18nKey="conversations:contactInteractionBubble.phoneCall.aiCallAnalysis.analyzing"
          values={{
            action: title,
          }}
          components={{
            strong: <InteractionDetailsBadgeStrongText />,
          }}
        />
      );
    }

    return <InteractionDetailsBadgeStrongText>{title}</InteractionDetailsBadgeStrongText>;
  }, [inProgress, title]);

  return (
    <InteractionDetailsBadgeContainer
      $type={type}
      icon={icon}
      badgeContent={badgeContent}
      {...rest}
    />
  );
};
